import { CheckCircle2, CircleDot, CircleX, EyeOff, FilePenLine } from "lucide-react";

/** Lucide glyph aligned with role status tiles (dashboard + role workspace). Stroke 1.75 per hiring UI guide. */
export function HiringRoleStatusGlyph({ variant, className = "hiring-role-status-option__icon", size = 16 }) {
  const p = { className, size, strokeWidth: 1.75, "aria-hidden": true };
  switch (variant) {
    case "active":
      return <CheckCircle2 {...p} />;
    case "hidden":
      return <EyeOff {...p} />;
    case "closed":
      return <CircleX {...p} />;
    case "draft":
      return <FilePenLine {...p} />;
    default:
      return <CircleDot {...p} />;
  }
}
